export const COURIERS = [
  { value: "", label: "Tanpa Ekspedisi" },
  { value: "J&T Express", label: "J&T Express" },
  { value: "JNE", label: "JNE" },
  { value: "SiCepat", label: "SiCepat" },
  { value: "Shopee Xpress", label: "Shopee Xpress" },
  { value: "GoSend", label: "GoSend" },
  { value: "GrabExpress", label: "GrabExpress" },
  { value: "AnterAja", label: "AnterAja" },
  { value: "Ninja Xpress", label: "Ninja Xpress" },
  { value: "POS Indonesia", label: "POS Indonesia" },
  { value: "ID Express", label: "ID Express" },
  { value: "Lion Parcel", label: "Lion Parcel" },
];

export const PAPER_SIZES = {
  "100x150": { w: 100, h: 150, label: "100 × 150 mm (Standar Resi)" },
  "100x100": { w: 100, h: 100, label: "100 × 100 mm (Sedang)" },
  "80x50": { w: 80, h: 50, label: "80 × 50 mm (Label Kecil)" },
  "50x30": { w: 50, h: 30, label: "50 × 30 mm (Stiker Mini)" },
};
